import React from 'react';

import Chip from '@mui/material/Chip';

const ColorStringCellRenderer = ({ value: { value, color } }) => {
  return <Chip label={value} size="small" color={color} sx={{ width: '100%', justifyContent: 'start' }} />;
};

export default ColorStringCellRenderer;
